import { render, staticRenderFns } from "./HotelReviews.vue?vue&type=template&id=31b522ee&scoped=true&"
import script from "./HotelReviews.vue?vue&type=script&setup=true&lang=ts&"
export * from "./HotelReviews.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./HotelReviews.vue?vue&type=style&index=0&id=31b522ee&prod&lang=scss&"
import style1 from "./HotelReviews.vue?vue&type=style&index=1&id=31b522ee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b522ee",
  null
  
)

export default component.exports